import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

export default function ConcentrationChart({ history, color, label, onPointClick }) {
  if (!history || history.length === 0) return null;
  const clickable = typeof onPointClick === "function";

  const Dot = (props) => {
    const { cx, cy, payload } = props;
    if (cx == null || cy == null) return null;
    return (
      <g style={clickable ? { cursor: "pointer" } : undefined}
         onClick={clickable ? (e) => { e.stopPropagation(); onPointClick(payload); } : undefined}>
        {clickable && <circle cx={cx} cy={cy} r={11} fill="transparent" />}
        <circle cx={cx} cy={cy} r={4} fill={color} stroke="#fff" strokeWidth={1.5} />
      </g>
    );
  };
  const ActiveDot = (props) => {
    const { cx, cy, payload } = props;
    if (cx == null || cy == null) return null;
    return (
      <g style={clickable ? { cursor: "pointer" } : undefined}
         onClick={clickable ? (e) => { e.stopPropagation(); onPointClick(payload); } : undefined}>
        <circle cx={cx} cy={cy} r={13} fill={color} fillOpacity={0.12} />
        <circle cx={cx} cy={cy} r={6} fill={color} stroke="#fff" strokeWidth={2} />
      </g>
    );
  };

  return (
    <div className="h-48 w-full">
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={history} margin={{ top: 8, right: 12, left: -18, bottom: 0 }}>
          <CartesianGrid stroke="#f1f1f1" vertical={false} />
          <XAxis dataKey="year" tick={{ fontSize: 11, fill: "#737373" }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fontSize: 11, fill: "#737373" }} axisLine={false} tickLine={false} unit="%" />
          <Tooltip
            contentStyle={{ border: "1px solid #e5e5e5", borderRadius: 8, fontSize: 12, fontFamily: "IBM Plex Mono" }}
            formatter={(v) => [`${v}%`, label]}
          />
          <Line type="monotone" dataKey="pct" stroke={color} strokeWidth={2} dot={<Dot />} activeDot={<ActiveDot />} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
